<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import TilPricingComponent from './component.til.pricing.svelte'
    import TilPricingsComponent from './component.til.pricings.svelte'
    import TilPricingUpdateComponent from './component.update.svelte'
    import TilPricingUploadComponent from './component.upload.svelte'
    import TilPricingDownloadComponent from './component.download.svelte'
    import TilPricingCreateComponent from './component.create.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Precios TIL" subtitle="Consulta y gestión de precios TIL" />
        <TilPricingsComponent />
    </div>
</View>

<ModalContainer id="tilPricing_modal" title="Precio TIL" >
    <TilPricingComponent />
</ModalContainer>

<ModalContainer id="tilPricing_create_modal" title="Registrar precio TIL" >
    <TilPricingCreateComponent />
</ModalContainer>

<ModalContainer id="tilPricing_update_modal" title="Actualizar precio TIL" >
    <TilPricingUpdateComponent />
</ModalContainer>

<ModalContainer id="tilPricing_upload_modal" title="Cargar precios TIL" >
    <TilPricingUploadComponent />
</ModalContainer>

<ModalContainer id="tilPricing_download_modal" title="Descargar precios TIL" >
    <TilPricingDownloadComponent />
</ModalContainer>
